<template>
    <div>
        <iframe v-show="false" ref="myIframe" style="width: 100%; height: 500px" />

        <div v-show="false" id="xapp" ref="xapp">
            <!-- <div class="html2pdf__page-break"></div> -->
            <h4 class="text-center" style="margin-bottom: 2em;"> CONTRATO POR PRESTACION DE SERVICIOS ACADEMICOS CURSO DE IDIOMA INGLÉS {{ data.codigo_contrato }} </h4>

            <p>
                Conste por el tenor del presente documento privado, CONTRATO POR PRESTACIÓN DE SERVICIOS ACADÉMICOS, mismo que a sólo reconocimiento de firmas y rúbricas ante Autoridad competente surtirá los efectos de Instrumento Público, de conformidad con lo dispuesto por el Art. 519 y 1.297 del Código Civil con sujeción a las siguientes cláusulas:
            </p>

            <p>
                PRIMERA. - (DE LAS PARTES). - Son partes del presente documento:
            </p>
            <p>
                Por una parte: La Escuela de Negocios ESAM S.R.L. con domicilio real Calle Prolongación Quijarro #126, casi esquina Acre, entre 1er. y 2do. Anillo ciudad de Santa Cruz de la Sierra representada por Marcela Aramayo Marañon con cédula de identidad No 5797536 expedida en Tarija vecina de ésta, de nacionalidad boliviana y hábil por ley en su calidad de Gerente Regional, de aquí en adelante EL ACREEDOR: "ESAM- GO UP Academy "
            </p>

            <p>
                Y por otra parte: El señor(a) <span class="edit"> {{data.estudiante}} </span> de nacionalidad <span class="edit">{{data.nacionalidad}}</span> domiciliado en <span class="edit"> {{data.domicilio}} </span> con C.I <span class="edit">{{data.documento}}</span> de aquí en adelante EL DEUDOR: EL CURSANTE.
            </p>

            <p>
                SEGUNDA. (DEL OBJETO). - A la presente el CURSANTE de su libre y espontánea voluntad y por convenir así a sus intereses contrata los Servicios Académicos de la Escuela de Negocios ESAM, para realizar el curso de IDIOMA INGLES
            </p>
            <p>
                Por el mismo, el CURSANTE deberá realizar el pago del COSTO DEL PROGRAMA DE IDIOMA INGLÉS monto que equivale la suma de Bs <span class="edit">{{data.monto_total}}</span> (<span class="edit">{{data.monto_total_str}}</span> 00/100 bolivianos).
            </p>
            <p>
                TERCERA. - (CARACTERÍSTICAS DEL PROGRAMA). -
            </p>

            <p>
                GO UP Academy es una plataforma de aprendizaje INTERNACIONAL autogestionado de inglés que aplica IA en cada uno de los niveles y en el seguimiento y control del aprendizaje de los estudiantes, GO UP Academy está alineada con el sistema de competencia de idiomas del Marco Común Europeo de Referencia para las Lenguas (MCER).
            </p>

            <p>
                Para acceder a GO UP puede ser desde una computadora (versión web) o de un celular (versión web o app). El avance es a través de metodologías de aprendizaje activo. aprende a través de vídeos, audios y textos mientras realiza los ejercicios. Como resultado, el estudiante internaliza el contenido de forma natural y aprende de manera más significativa. El contenido gramatical y el vocabulario se presentan a los estudiantes de forma implícita, natural y contextualizada dentro de los propios ejercicios.
            </p>

            <p>
                CUARTA. - (ESTRUCTURA ACADÉMICA DEL PROGRAMA)
            </p>
            <p>
                ESAM - GO UP Academy ha desarrollado un camino de aprendizaje completo de acuerdo con el estándar MCER que lleva al estudiante desde el nivel principiante hasta el avanzado: Pre A1, A1, A1+, A2, A2+, B1, B1+, B2, B2+, C1, C2. Esta división de cursos funciona como una forma de fijar el contenido del curso anterior e iniciar el contenido del siguiente para hacer más gradual la transición entre niveles para el estudiante.
            </p>

            <table class="tabla1">
                <thead>
                    <tr>
                        <th> NIVEL </th>
                        <th> HORAS POR NIVEL </th>
                        <th> DESCRIPCION </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td> Pre A1 </td>
                        <td> 30 horas </td>
                        <td> Comprender estructuras muy básicas, desarrolla habilidades para pedir información, y responder a preguntas simples con respuestas cortas. </td>
                    </tr>

                    <tr>
                        <td> A1 </td>
                        <td> 60 horas </td>
                        <td> Comprender y utilizar expresiones y frases cotidianas muy básicas para satisfacer necesidades concretas e interactuar de manera muy sencilla sobre temas familiares rutinarios. </td>
                    </tr>
                    <tr>
                        <td> A1+ </td>
                        <td> 60 horas </td>
                        <td> Comprender y utilizar expresiones y frases concretas para dar instrucciones, hacer sugerencias y describir el clima. </td>
                    </tr>
                    <tr>
                        <td> A2 </td>
                        <td> 55 horas </td>
                        <td> Comprender oraciones y expresiones frecuentemente utilizadas relacionadas con información personal, realizar peticiones, describir personas y cosas, o expresar preferencias. </td>
                    </tr>
                    <tr>
                        <td> A2+ </td>
                        <td> 80 horas </td>
                        <td> Comprender oraciones y expresiones frecuentemente utilizadas relacionadas con tareas simples y rutinarias, como verificar la comprensión, describir experiencias y eventos, sentimientos y emociones </td>
                    </tr>
                    <tr>
                        <td> B1 </td>
                        <td> 80 horas </td>
                        <td> Ser capaz de comunicarse en entornos familiares, como el trabajo, y la escuela, expresando opiniones, manejando la interacción, hablando sobre posibilidades/probabilidades y aconsejando a otros. </td>
                    </tr>
                    <tr>
                        <td> B1+ </td>
                        <td> 80 horas </td>
                        <td> Ser capaz de comunicarse en entornos familiares, como el trabajo, la escuela y el ocio, criticar y revisar, describir deseos y planes, aspiraciones, desarrollar un argumento y expresar opiniones concretas </td>
                    </tr>
                    <tr>
                        <td> B2 </td>
                        <td> 65 horas </td>
                        <td> Ser capaz de interactuar con un grado de fluidez y espontaneidad que permita una interacción regular, expresando opiniones, ideas abstractas, especulaciones, describiendo causas y efectos y aclarando información. </td>
                    </tr>
                    <tr>
                        <td> B2+ </td>
                        <td> 65 horas </td>
                        <td> Ser capaz de interactuar con un grado de fluidez y espontaneidad que permita el desarrollo de un argumento de manera sistemática, respondiendo a contraargumentos, defendiendo un punto de vista de manera persuasiva, y precisa. </td>
                    </tr>
                    <tr>
                        <td> C1 </td>
                        <td> 70 horas </td>
                        <td> Ser capaz de expresarse con fluidez y espontaneidad sin mostrar mucho esfuerzo para encontrar una palabra o expresión adecuada; utilizando el idioma de manera efectiva y precisa para fines sociales, académicos y profesionales, comprendiendo </td>
                    </tr>
                    <tr>
                        <td> C2 </td>
                        <td> 70 horas </td>
                        <td> Ser capaz de comprender con facilidad prácticamente todo lo que se escucha o lee, resumiendo información de diferentes fuentes habladas y escritas, reconstruyendo argumentos y relatos en una presentación coherente expresándose de manera espontánea y muy fluida. </td>
                    </tr>

                </tbody>
            </table>

            <p>
                QUINTA. - (RESPONSABILIDADES DE LOS CURSANTES). - Son responsabilidades de los CURSANTES:
            </p>
            <p>
                <ol type="a">
                    <li> a) Mantener y guardar respeto con las autoridades. </li>
                    <li> b) Someterse a las evaluaciones de cada uno de los módulos en los plazos estipulados. </li>
                    <li> c) Para optar el certificado del programa deberá finalizar y aprobar el examen de cada nivel. </li>
                    <li> d) Cumplir puntualmente con la inversión del programa en las fechas y montos establecidos. </li>
                    <li> e) Es responsabilidad del CURSANTE, presentar toda la documentación legal y fidedigna en plazos y formatos definidos. </li>
                </ol>
            </p>

            <div>
                <p> SEXTA. - (RESPONSABILIDADES DE LA ESAM GO UP) </p>
                <ol type="a">
                    <li> a) "ESAM- GO UP Academy "realizará seguimiento y evaluaciones periódicas bajo diferentes criterios de la coordinación académica (Tutor guía) </li>
                    <li> b) Proveer acceso y soporte a la plataforma para desarrollo del programa. </li>
                    <li> c) Desarrollar los niveles de acuerdo a la propuesta académica. </li>
                    <li> d) "ESAM- GO UP Academy "viabilizará la certificación con GO UP Academy, de acuerdo a la estructura académica propuesta. </li>
                </ol>
            </div>

            <div>
                <p> SÉPTIMA. - (INVERSIÓN Y FORMA DE PAGO). - EL CURSANTE, deberá realizar las cancelaciones económicas a la ESAM por los siguientes conceptos: </p>
                <ol type="a">
                    <li> a) Colegiatura Bs <span class="edit">{{data.monto_total}}</span> (<span class="edit">{{data.monto_total_str}}</span> 00/100 bolivianos). </li>
                    <span> La solicitud de devolución económica solo se protocoliza dentro del mes de inscripción, mediante carta y respaldo justificado. </span>
                    <li> b) El trámite de Certificación, no implica un costo adicional. </li>
                    <li> c) El pago podrá efectuarse en 12 cuotas hasta el 01 de cada mes, para habilitación a la plataforma GO UP. </li>
                </ol> 
            </div>
            
            <p>
                El plan de pagos será el siguiente:
            </p>
            <div>
                <table class="tabla3">
                    <thead>
                        <tr>
                            <th> Cuota Nro. </th>
                            <th> Concepto </th>
                            <th> Monto </th>
                            <th> Fecha Vencimiento </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p,i) in data.pagos" :key="i">
                            <td> {{ p.nro_cuota }} </td>
                            <td> {{ p.concepto_pago }} </td>
                            <td> {{ p.total }} </td>
                            <td> {{ p.fecha_pago }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p>
                En caso de incumplimiento de pago dentro de las fechas establecidas, la falta de pago de 3 cuotas, el CURSANTE se constituirá en mora sin necesidad de requerimiento judicial, y la suma adeudada será liquida y exigible y de plazo vencido y el ACREEDOR podrá interponer el proceso ejecutivo. 
            </p>

            <p>
                OCTAVA. - (EN CASO SUSPENSIÓN). -
            </p>
            <p>
                Suspensión. - Se considera Suspensión en los casos que El CURSANTE debiera interrumpir temporalmente sus estudios por un tiempo que no exceda de un módulo (es decir 1 mes) del plan de estudios del programa cursado, deberá presentar por escrito su solicitud de suspensión en la que especifique el tiempo y las causales, siendo admisibles solo por motivos laborales y de salud, deberá adjuntar los documentos que den fe y respalden la solicitud de suspensión también deberá acompañar la constancia de haber cubierto el monto económico. 
            </p>

            <p>
                NOVENA. - (DOMICILIO REAL). - Las partes establecen que para efectos de su legal citación podrán ser citados en los domicilios declarados en sus generales de ley, teniendo la obligación de informar a la ESAM mediante carta notarial en caso de que se realizará cambio de domicilio, de no hacerlo serán citados en el domicilio declarado por ellos en el presente contrato.
            </p>
            <p>
                DÉCIMA PRIMERA. - (ACEPTACIÓN AL PROGRAMA). - EL CURSANTE, acepta todas y cada una de las exigencias del programa.
            </p>
            <p>
                EL CURSANTE conoce y declara que el presente curso es solo de formación básica, no implica formación técnica, ni profesional.
            </p>
            <div class="page-new"></div>
            <p>
                El DEUDOR autoriza al ACREEDOR para a partir de la firma del presente contrato, y hasta la fecha de vencimiento de la última de sus obligaciones con éste, pueda solicitar y obtener información de su situación crediticia en cualquier entidad pública o privada del Sistema Financiero Nacional, Centrales de Información de Riesgos u otro  legalmente autorizados por la ASFI o cualquier otra entidad administradora de datos a efectos de puedan velar por sus intereses con relación a la solvencia del DEUDOR para que cumpla así con sus obligaciones asumidas.
            </p>
            <p>
                El DEUDOR autoriza expresamente al ACREEDOR para que lleve a cabo consultas y verificaciones a través de los servicios INFOCENTER de ENSERBIC S.A., para conocer la situación que presento respecto de las obligaciones y los antecedentes personales.
    Del mismo modo, que la organización autorizada reporte a ENSERBIC S.A., información referida a mis datos como cliente, así como al endeudamiento que he mantenido o mantenga en el futuro, autorizando que estos registros puedan ser consultados por terceras personas a través de ENSERBIC S.A., para efectos y control y cumplimiento del Reglamento para la Constitución y Funcionamiento de Burós de Información Crediticia.
            </p>
            <p>
                DÉCIMA SEGUNDA. - (ACEPTACIÓN). - Nosotros, "ESAM", con representación de Marcela Aramayo Marañón Gerente Regional por una parte y "EL CURSANTE " por otra, de forma voluntaria y sin que medie ningún vicio del consentimiento, declaramos nuestra total conformidad con todas y cada una de las cláusulas precedentes, en fe de lo cual firmamos en tres ejemplares de un solo tenor y nos comprometemos a su fiel y estricto cumplimiento, el cual es firmado en la ciudad de Santa Cruz de la Sierra a los <span class="edit">{{data.dias}}</span> días del mes de <span class="edit">{{data.mes}}</span> del año <span class="edit">{{data.anio}}</span>.
            </p>

            <div>
                <table class="tabla2">
                    <tbody>
                        <tr>
                            <td>
                                <p>Marcela M. Aramayo Marañón</p>
                                <p>ESAM- GERENTE</p>
                                <p>ACREEDOR</p>
                            </td>
                            <td>
                                <p> {{data.estudiante}} </p>
                                <p>CURSANTE</p>
                                <p>DEUDOR</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        
    </div>
</template>



<script>
import xaxios from '@/xaxios';

export default {
    data() {
        return {
            loading: false,
            only_download: false,
            thiz: {},
            dataz:{},
            data: {
                estudiante: '',
                domicilio: '',
                nacionalidad: '',
                documento: '',
                monto_total: '',
                monto_total_str: '',
                codigo_contrato: '',
                dias: '',
                mes: '',
                anio: '',
                pagos: [],
            }
        }
    },
    methods:{
        async getPlan(idinscripcion){
            this.loading = true;
            const url5 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
            const res = await xaxios.get(url5).then(({data})=>data)
            this.loading = false;
            this.data.pagos = res.data;
            window.console.log('idinscripcion:',this.data.pagos);
        },
        xmes(m){
            const meses = {
                1: 'enero',
                2: 'febrero',
                3: 'marzo',
                4: 'abril',
                5: 'mayo',
                6: 'junio',
                7: 'julio',
                8: 'agosto',
                9: 'septiembre',
                10: 'octubre',
                11: 'noviembre',
                12: 'diciembre'
            };
            return meses[m];
        },
        async setData(d, thizz){
            this.thiz = thizz;
            this.dataz = d;
            this.data.codigo_contrato = '';
            thizz.loading_goup = true;
            const writtenNumber = require('written-number');
            const xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
            // const prog = JSON.parse(sessionStorage.getItem('xprograma'));
            const domicilio = xinscripcion.estudiante.domicilio;
            const da = new Date();
            const dia = da.getDate();
            const mes = da.getMonth()+1;
            const anio = da.getFullYear();
            let nacionalidad = '';
            if (xinscripcion.estudiante.pais) nacionalidad = xinscripcion.estudiante.pais.nombre;

            if (!domicilio) {
                this.$root.$notify.show('Falta el domicilio del participante.', { color: 'red' });
                return;
            }
            if (!nacionalidad) {
                this.$root.$notify.show('Falta la nacionalidad del participante.', { color: 'red' });
                return;
            }
            if (!xinscripcion.estudiante.ciudad) {
                this.$root.$notify.show('Falta la ciudad del participante.', { color: 'red' });
                return;
            }

            await this.getPlan(d.id);

            let xtotal = 0;
            this.data.pagos.forEach(x=>xtotal += x.total);
            let xtotal_str = writtenNumber(xtotal, { lang: 'es' }); 

            const e = xinscripcion.estudiante;
            if(!e.seg_apellido) e.seg_apellido = '';

            this.data.estudiante = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`;
            this.data.domicilio = domicilio;
            this.data.nacionalidad = nacionalidad;
            this.data.documento = e.num_doc;
            this.data.monto_total = xtotal;
            this.data.monto_total_str = xtotal_str;
            this.data.dias = dia;
            this.data.mes = this.xmes(mes);
            this.data.anio = anio;
            window.console.log('this.data', d);
            thizz.loading_goup = false;

            

            // SOLO DESCARGAR
            if(this.only_download){
                await this.sleep(300);
                this.renderFrame();
            }else{
                this.guardarDataContrato();
                // GENERAR CODIGO Y DESCARGAR
            }
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async renderFrame(){
            const iframe = this.$refs.myIframe;
            const vue = this;
            iframe.onload = async function () {
                const cd = iframe.contentDocument;
                var iframeDocument = cd || iframe.contentWindow.document;
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'css/contragoup.css';
                link.onload = async () => {
                    await vue.sleep(500);
                    vue.otro(); 
                }
                link.onerror = () => {
                    window.alert('No se pudo cargar el estilo, inter lento :(, vuelve a intetarlo')
                }
                iframeDocument.head.appendChild(link);

            };

            const doc = iframe.contentDocument || iframe.contentWindow.document;
            doc.open();
            const refxapp = this.$refs.xapp;
            doc.write(refxapp.innerHTML);
            doc.close();
        },
        async otro(){
            const iframe = this.$refs.myIframe;
            const iframeWindow = iframe.contentWindow;
            const iframeDocument = iframeWindow.document;
            const container = document.createElement('div');
            container.innerHTML = iframeDocument.documentElement.innerHTML;

            const existingStyles = container.querySelectorAll('style, link[rel="stylesheet"]');
            existingStyles.forEach(style => style.remove());

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'css/contragoup.css';
            container.appendChild(link);

            const wrapper = document.createElement('div');
            wrapper.appendChild(container);

            window.html2pdf().from(wrapper).set({
                margin: 1,
                filename: `contrato-${this.data.estudiante}.pdf`,
                html2canvas: { scale: 2 },
                pagebreak: {  mode: ['avoid-all', 'css', 'legacy'],before:'page-new', avoid: ['div'] },
                jsPDF: { unit: 'in', format: 'legal', orientation: 'portrait',compressPDF: true }
            }).output('datauristring').then((pdf)=>this.subirToServer(pdf));
        },
        async subirToServer(pdfAsString){
            if(this.only_download){
                const linkSource = pdfAsString;
                const downloadLink = document.createElement('a');
                downloadLink.href = linkSource;
                downloadLink.download = `contrato-${this.data.estudiante}.pdf`;
                downloadLink.click();
                return;
            }
            this.thiz.loading_goup = true;
            const contrato_id = this.data.contrato_id;
            let datasend = {
                contrato_id: contrato_id,
                is_enviar: false,
                correo: contrato_id+'-estudiante@gmail.com',
                pdf:  pdfAsString,
            };
            const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/pdf`;
            const res = await xaxios.post(url, datasend);
            // window.console.log('ressss>>>',res.data);

            if( res && res.data ){
                const linkSource = datasend.pdf;
                const downloadLink = document.createElement('a');
                downloadLink.href = linkSource;
                downloadLink.download = `contrato-${this.data.estudiante}.pdf`;
                downloadLink.click();
            }
            this.thiz.loading_goup = false;

        },
        async guardarDataContrato(){
            const input = {}

            const xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
            const prog = JSON.parse(sessionStorage.getItem('xprograma'));

            if(!xinscripcion.estudiante.ciudad) xinscripcion.estudiante.ciudad = {};
            if(!xinscripcion.estudiante.pais) xinscripcion.estudiante.pais = {};
            input.ciudad = xinscripcion.estudiante.ciudad.nombre;
            input.direccion = xinscripcion.estudiante.domicilio;
            input.inscripcion_id = xinscripcion.id;
            const mods = [];
            prog.programa_modulos.forEach((x,i)=> mods.push({modulo:x.modulo.nombre,numero:i+1,sigla:x.modulo.sigla,tipo:'MOD'}) )
            input.modulos = mods;
            input.participante = this.data.estudiante;
            input.participante = this.data.estudiante;
            input.participante_ci = this.data.documento;
            input.participante_domicilio = xinscripcion.estudiante.domicilio;
            input.participante_id = xinscripcion.estudiante.id;
            input.participante_nacionalidad = xinscripcion.estudiante.pais.nombre;
            input.pdf = 'string';
            const pagos = [];
            let total = 0;
            this.data.pagos.forEach(x=>{
                total += x.total;
                pagos.push({concepto_pago:x.concepto_pago,fecha_pago:x.fecha_pago,monto:x.total,nro_cuota:parseInt(x.nro_cuota)})
            })
            input.plan_pagos = pagos;
            input.programa_carga_horario = 120;
            input.programa_colegiatura_contado = total;
            input.programa_colegiatura_monto = total;
            input.programa_matricula_monto = 0;
            input.programa_monto = total;
            input.programa_nombre = prog.nombre_compuesto;
            input.programa_tipo = 'curso';
            input.representante = 'Marcela Aramayo';
            input.representante_ci = '12345678';
            input.representante_expedido = 'Ext';

            // window.console.log('>>>>>',xinscripcion, prog,'\n--',input);
            const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/`
            const res = await xaxios.post(url,input).then(({data})=>data).catch(e=>e)
            // window.console.log(':::>>>', res);
            this.thiz.loading_goup = true;
            if( res && res.data ){
                this.data.codigo_contrato = res.data.codigo;
                this.data.contrato_id = res.data.contrato_id;
                await this.sleep(300); 
                this.renderFrame();
            }
            if(res && res.response){
                const t = res.response.data.data;
                window.console.log(':::>>>t', t);
                this.$root.$notify.show(t, { color: 'red' });
                this.thiz.loading_goup = false;
                this.descargarYaGenerado();
            }

        },

        async descargarYaGenerado(){
            this.thiz.loading_goup = true;
            const idpersona = this.dataz.estudiante.id;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${idpersona}/persona`;
            const res = await xaxios.get(url);
            if(res && res.data){
                const certs = res.data.data;
                const idins = this.dataz.id;
                const contra = certs.find(x=>x.inscripcion_id == idins);

                if(contra){
                    const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${contra.id}/pdf`;
                    const res = await xaxios.get(url);
                    window.console.log('res', res.data);
                    if(res && res.data){
                        const linkSource = res.data.data;
                        const downloadLink = document.createElement('a');
                        downloadLink.href = linkSource;
                        downloadLink.download = `copia-contrato-${this.data.estudiante}.pdf`;
                        downloadLink.click();
                    }
                }

            }

            this.thiz.loading_goup = false;
        }
    },
    mounted() {
        window.console.log('montado');
        
    }
}
</script>